import {postSignUser} from '../api/postSignUser';

const setPostSignUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postSignUser(params);
            if (data.status === 'success') {
                window.open(data.url, '_blank')
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostSignUser
}